import React from "react";
import ParagraphText from "components/Paragraphs/ParagraphText";
import ParagraphImage from "components/Paragraphs/ParagraphImage";
import ParagraphDisclosures from "components/Paragraphs/ParagraphDisclosures";
import ParagraphDisclosure from "components/Paragraphs/ParagraphDisclosure";
import ParagraphGrid from "components/Paragraphs/ParagraphGrid";
import ParagraphCard from "components/Paragraphs/ParagraphCard";
import ParagraphFiles from "components/Paragraphs/ParagraphFiles";
import ParagraphVideo from "components/Paragraphs/ParagraphVideo";
import ParagraphBannerFile from "components/Paragraphs/ParagraphBannerFile";
import ParagraphCalculator from "components/Paragraphs/ParagraphCalculator";
import classNames from "lib/classNames";

export default function Paragraphs({ paragraphs, level = 0, ...props }) {
  const components = {
    "paragraph--text": ParagraphText,
    "paragraph--image": ParagraphImage,
    "paragraph--disclosure": ParagraphDisclosures,
    "paragraph--collapse": ParagraphDisclosure,
    "paragraph--grid": ParagraphGrid,
    "paragraph--card": ParagraphCard,
    "paragraph--files": ParagraphFiles,
    "paragraph--file_banner": ParagraphBannerFile,
    "paragraph--private_file_banner": ParagraphBannerFile,
    "paragraph--video": ParagraphVideo,
    "paragraph--calculator": ParagraphCalculator,
  };

  return (
    <>
      {paragraphs.map((paragraph, index) => {
        if (Object.prototype.hasOwnProperty.call(components, paragraph.type)) {
          const ParagraphComponent = components[paragraph.type];

          return (
            <div
              key={paragraph.id}
              className={classNames(level === 0 && "mt-16")}
            >
              <ParagraphComponent
                data={paragraph}
                loopIndex={index}
                level={level}
                {...props}
              />
            </div>
          );
        }

        console.warn(
          `Unknown paragraph type "${paragraph.type}" at tree level ${level}.`
        );
        return null;
      })}
    </>
  );
}
